export default {"src":"/_next/static/media/ic-sentiment-5.84700f8b.svg","height":29,"width":28,"blurWidth":0,"blurHeight":0};